import { combineReducers } from 'redux';
import { merchZone, merchZoneLoading, merchZoneError } from './merchZoneReducer';
import { availability } from './availabilityReducer';

const rootReducer = combineReducers({
    merchZone,
    merchZoneLoading,
    merchZoneError,
    availability
});

export default rootReducer;